<!-- Beginning of the right draw -->
<template v-slot:default="{ on, attrs }">
  <v-card class="mx-auto" color="grey lighten-2">
    <v-navigation-drawer app right color="white" v-model="drawer" permanent>
      <!--
        bottom
        temporary 
        absolute
        :mini-variant.sync="mini"
        <v-icon @click.stop="mini = !mini" class="pr-2">mdi-chevron-right</v-icon>
        -->
      <v-list-item class="pt-2 px-2">
        <!--Beginning of profile sheet-->
        <v-bottom-sheet width="1200px">
          <template v-slot:activator="{ props, on }">
            <v-btn color="transparent" elevation="0" class="pl-3" v-bind="props" v-on="on" v-model="sheet">
              <v-list-item-group class="text-left">
                <v-list-item-title>{{ user.first_name }} {{ user.last_name }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption">{{ user.email }}</v-list-item-subtitle>
              </v-list-item-group>
            </v-btn>
          </template>
          <!------------------------------>
          <profilePage />
          <!--End of sheet profile-->
        </v-bottom-sheet>
        <!--end of profile sheet-->
        <!---->
      </v-list-item>
      <v-dialog v-model="dialog" width="1024">
        <template v-slot:activator="{ on, props }">
          <v-list-item-title class="pl-5 font-weight-normal" color="blue darken-2">
            <v-btn v-bind="props" v-on="on" color="grey" icon="true"
              @click="toggleJobForm"><v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>
            Upload Project Ideas
          </v-list-item-title>
        </template>
        <ideaForm @handle-toggle-form="toggleJobForm" @fetch-business-ideas="getBusinessIdeas" />
      </v-dialog>
      <!-- Dropdown menu begins here -->
      <!-- List item begins here -->
      <v-list-item v-for="item in items" :key="item.id" link color="white">
        <v-row dense>
          <v-col>
            <v-list dense>
              <v-card>
                <v-list-item class="pa-0 text-caption">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <v-img :src="item.company_logo" max-width="25" contain alt="company logo"></v-img>
                        <v-list-item-title class="pl-1">
                          {{ item.title }} 
                        </v-list-item-title>
                      </v-expansion-panel-header>
                      <v-progress-linear buffer-value="90" value="60" stream color="blue"></v-progress-linear>
                      <v-expansion-panel-content>
                        {{ truncateDescription(item.description, 100) }}
                        <v-card-actions>
                          <v-btn v-bind="attrs" v-model="sheet" v-on="on" color="blue" @click="toggleProfilePage"
                            x-small text right>
                            <a :href="''+ item.website_link" target="_blank">View More</a>
                          </v-btn>
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-list-item>
              </v-card>
            </v-list>
          </v-col>
        </v-row>
      </v-list-item>
      <!--Ending of second right draw-->
      <!-- Drop down menu's end here -->
      <div class="bottom-div">
      <v-list-item-title class="px-5 pb-0 text-caption">
        Contacts
        <v-icon color="blue" dark>mdi-account-plus</v-icon>
        <v-badge bordered color="green" content="6"></v-badge>
      </v-list-item-title>
      <v-card class="mx-auto pl-5" outlined color="transparent">
        <v-row v-for="n in 4" :key="n" cols="3" xs="3" sm="3" class="pa-0" no-gutters>
          <v-col v-for="n in 4" :key="n" cols="3" xs="3" sm="3" class="pb-1">
            <v-avatar size="35">
              <v-img alt="" :src="`https://randomuser.me/api/portraits/thumb/men/${n}.jpg`"></v-img>
            </v-avatar>
          </v-col>
        </v-row>
      </v-card>
      <v-col no-gutters cols="12" class="pt-0">
        <v-btn class="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default primary" @click="logOut">
          Log out
        </v-btn>
      </v-col>
        <v-col color="white darken-4" cols="12" class="pt-0 pb-0">
          <v-text-field v-model="message4" label="Search..." outlined clearable></v-text-field>
        </v-col>
      </div>
      <!--
        <v-fade-transition>
        <v-overlay
          v-if="hover"
          absolute
          color="#01579B"
        >
          <v-btn>Coming soon...</v-btn>
        </v-overlay>
      </v-fade-transition>
      -->
    </v-navigation-drawer>
  </v-card>
</template>
<script>
import axios from 'axios'
import { apiUrl } from '../config'
import { mapGetters, mapState } from 'vuex'
import ideaForm from './ideaForm'
import profilePage from './profilePage'
export default {
  data: () => ({
    showProfilePage: false,
    drawer: false,
    dialog: "",
    sheet: "",
    message4: "",
    API_URL: apiUrl,
    profileData: [""],
    profile_image: '',
    items: [

    ],
    mini: true,
  }),
  computed: {
    ...mapState(['user']),
    ...mapGetters({ user: "auth/user" }),
  },
  components: {
    profilePage,
    ideaForm
  },
  methods: {
    truncateDescription(description, limit) {
      if (description.length <= limit) {
        return description;
      }
      return description.substring(0, limit) + '...';
    },
    async getBusinessIdeas() {
      console.log('fetch get business ideas function triggered')
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}business-ideas/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        console.log("business ideas ====>", response.data);
        this.items = response.data;


      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    async getProfileData() {
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}users/current-user/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        this.profileData = response.data;
        this.profile_image = this.profileData?.profile.profile_image;
        console.log(this.profileData);

      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    toggleJobForm() { 
      this.dialog = !this.dialog;
      console.log(this.dialog)
      console.log('emmitted')
    },
    toggleProfilePage() {
      this.showProfilePage = !this.showProfilePage;
    },
    reserve() { },
    logOut() {
      this.$store.dispatch("auth/logout").then(res => {
        this.$success(res)
        this.$router.push("/")
      })
    },
  },
  created() {
    this.getProfileData();
    this.getBusinessIdeas();
  },
}
</script>
<style>
.bottom-div {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #FFF;
  padding: 16px;
}
</style>